import firebase from 'firebase/app';
import 'firebase/analytics';

class FirebaseService {
  constructor() {
    this.config = {
      apiKey: "AIzaSyBYENwxbJ7Qc6iAGBO70TZGEoEA-GxzdlM",
      authDomain: "wps-web-apps.firebaseapp.com",
      databaseURL: "https://wps-web-apps.firebaseio.com",
      projectId: "wps-web-apps",
      storageBucket: "wps-web-apps.appspot.com",
      messagingSenderId: "795794771984",
      appId: "1:795794771984:web:c60f008b6b97225f1cfa95",
      measurementId: "G-423DFWL0SD"
    };
    this.fireAnalytics = null;
  }

  init() {
    if (this.fireAnalytics) {
      return;
    }
    firebase.initializeApp(this.config);
    this.fireAnalytics = firebase.analytics();
  }

  setUserId(id) {
    if (this.fireAnalytics) {
      return;
    }
    this.fireAnalytics.setUserId(id);
  }

  collect(event, data) {
    if (!this.fireAnalytics) {
      return;
    }
    this.fireAnalytics.logEvent(event, data);
  }

};

export default FirebaseService;



// WEBPACK FOOTER //
// ./src/utils/firebase.js